import React, { Component } from 'react'

import { connect, batch } from 'react-redux';
import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux';
import { withStyles, Typography } from '@material-ui/core';


import { withRouter } from 'react-router';
import { getLocationPathName } from '../../selectors/util.selector';
import { DatePicker, DateTimePicker } from "material-ui-pickers";
import moment, { Moment } from 'moment'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import { isVarianceDialogOpen } from '../../selectors/phaseplan.selector';
import Dialog from '@material-ui/core/Dialog'
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button';
import { dialogActions } from '../../actions/dialog.actions';
import { ThunkDispatch } from 'redux-thunk';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { lookaheadActions } from '../../actions/lookahead.actions';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Variance, VarianceToEnglish } from '../../utils/Variance';

interface Props {
    isVarianceDialogOpen: boolean;
    closeDialogValue: () => void;
    classes: ClassNameMap,
    saveVariance: (variance: Variance) => void
}

type State = {
    variance: Variance
}


class AddVarianceDialog extends Component<Props, State> {
    state = {
        variance: "INACC_PLANNING",
    }

    handleChange = (event: any) => {
        
        this.setState({ [event.target.name]: event.target.value as Variance });
      }

    async closeDialog() {
        const { closeDialogValue } = this.props
        closeDialogValue()
    }

    onConfirm = () => {
        
        
        const { variance } = this.state
        const {  closeDialogValue, saveVariance } = this.props

        saveVariance(variance as Variance)

        closeDialogValue()

        
    }

    renderVariances = () => {
        return Object.entries(Variance).map(([key, value]) => {
            
            return (
                <MenuItem value={key}>{value}</MenuItem>
            )
        })
    }
    

    render() {
        const { classes } = this.props;

        return (
            <Dialog
                maxWidth='sm'
                fullWidth={true}
                open={!!this.props.isVarianceDialogOpen}
                
            >
                <DialogContent>
                    <div style={{backgroundColor: ''}} className={classes.DialogFormTitle}>
                        <p className={classes.DialogFormTitleText}>
                            Add Variance
                        </p>
                    </div>
                    <div className={classes.DialogFormContent} >
                        <FormControl style={{ minWidth: 120 }}>
                            <InputLabel htmlFor="">Variance</InputLabel>
                            <Select
                                value={this.state.variance}
                                onChange={this.handleChange}
                                inputProps={{
                                    name: 'variance'
                                }}
                            >
                                {this.renderVariances()}
                            </Select>
                        </FormControl>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closeDialog.bind(this)} color="secondary"> Cancel </Button>
                    <Button onClick={this.onConfirm}  color="primary"> Confirm </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const mapStateToProps = (state:any) => ({
    isVarianceDialogOpen: isVarianceDialogOpen(state),
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        closeDialogValue: () => dispatch(lookaheadActions.closeVarianceDialog()),
        saveVariance: (variance:Variance) => dispatch(lookaheadActions.saveVariance(variance))
    }
};


export default compose<React.ComponentClass>(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles, { withTheme: true }),
)( AddVarianceDialog)


// WEBPACK FOOTER //
// ./src/components/Dialogs/AddVarianceDialog.tsx